import { useRouter } from 'next/router';
import Link from 'next/link';
import { showConsentOnPage } from '../../utils/consent-utils';
import styles from './index.module.scss';

const Footer = () => {
  const router = useRouter();
  const showConsent = showConsentOnPage(router.pathname);

  return (
    <footer className={styles.pageFooter} role="contentinfo">
      <div className={styles.legalLinkContainer}>
        <Link href="/privacypolicy">
          <a className={styles.legalLink}>Privacy Policy</a>
        </Link>
        &nbsp;|&nbsp;
        <Link href="/user-agreement">
          <a className={styles.legalLink}>User Agreement</a>
        </Link>
        {showConsent && (
          <>
            <div className={styles.gdprConsentModule}>
              <br />
              <button
                className={`${styles.consentButton} ot-sdk-show-settings ot-sdk-btn`}
                id="ot-sdk-btn"
                onClick={() => {
                  // eslint-disable-next-line new-cap
                  if (window.OneTrust?.ToggleInfoDisplay) { window.OneTrust.ToggleInfoDisplay(); }
                }}
              >
                Manage Preferences
              </button>
            </div>
            <div className={styles.ccpaConsentModule}>
              <br />
              <button
                className={`${styles.consentButton} ot-sdk-show-settings ot-sdk-btn`}
                id="ot-sdk-btn"
                onClick={() => {
                  // eslint-disable-next-line new-cap
                  if (window.OneTrust?.ToggleInfoDisplay) { window.OneTrust.ToggleInfoDisplay(); }
                }}
              >
                DO NOT SELL OR SHARE MY PERSONAL INFORMATION
              </button>
            </div>
          </>
        )}
      </div>
    </footer>
  );
};

export default Footer;